export type TStringUndefined = string | undefined;
export type TString = string | null | undefined;
export type TNumber = number | null;

export interface IDefaultProps {
  className?: string;
}

export const ROLES = 'roles';
export type TFileState = 'uploaded' | 'paused' | 'staged';

export interface ISettings {
  expensesAlertLimit: number;
  dataFactoryName: string;
  dataFactoryUrl: string;
  dataStorageName: string;
  dataStorageUrl: string;
  databricksGettingStartedUrl: string;
  databricksWorkspaceId: string;
  databricksWorkspaceName: string;
  databricksWorkspaceUrl: string;
  fileSharePath: string;
  fileStorageUrl: string;
  globalscapeUrl: string;
  isDataFactoryEnabled: boolean;
  isPowerBiEnabled: boolean;
  isTableauEnabled: boolean;
  isAdoEnabled: boolean;
  powerBiEmbeddedCapacityIsEnabled: boolean;
  powerBiEmbeddedCapacityName: string;
  powerBiEmbeddedCapacitySku: string;
  powerBiWorkspaceName: string;
  powerBiWorkspaceUrl: string;
  projectCodeName: string;
  sqlServerName: string;
  sqlDbEdition: string;
  sqlDbName: string;
  sqlDbTier: string;
  tableauServer: string;
  tableauSiteName: string;
  tableauSiteUrl: string;
  projectBillCode: string;
  projectInformationOwner: string;
  projectManagingDirector: string;
  projectManager: string;
  azureDevOpsProjectUrl: string;
  azureDevOpsRepoUrl: string;
  userName: string;
  isApprover: boolean;
  clientName: string;
  currentMonthExpenses: number;
  previousMonthExpenses: number;
  expenseDetails: IExpenseDetail[];

  dataFactoryLinkedServicesUrl: string;
  powerBiWorkspaceId: string;
  powerBiSharedWorkspaceId: string;
  clientAnalystGroupName: string;
  clientStakeholderGroupName: string;
  consultantGroupName: string;
  engagementLeadGroupName: string;
  isDemoEnvironment: boolean;
  isLowLevelSecurity: boolean;
}

export interface IExpenseDetail {
  currentMonthExpenses: number;
  previousMonthExpenses: number;
  resourceId?: string;
  serviceName?: string;
}

export interface IPermissions {
  pbDataflowEnabled?: boolean;
  getPBReportsEnabled?: boolean;
  getPBSharedReportsEnabled?: boolean;
  updatePBReportEnabled?: boolean;
  pbReportEmbedEnabled?: boolean;

  getTReportsEnabled?: boolean;
  getTSharedReportsEnabled?: boolean;
  updateTReportEnabled?: boolean;
  tReportEmbedEnabled?: boolean;

  shareTReportEnabled?: boolean;
  unshareTReportEnabled?: boolean;
  sharePBReportEnabled?: boolean;
  unsharePBReportEnabled?: boolean;

  downloadPbidsFileEnabled?: boolean;
  updateSettingsEnabled?: boolean;
}

export enum USER_ROLES {
  CONSULTANT = 'Consultant',
  APPROVER = 'EngagementLead',
  CLIENT_STAKEHOLDER = 'ClientStakeholder',
  CLIENT_ANALYST = 'ClientAnalyst',
}

export interface IReport {
  displayName: string;
  description: string;
  id: string;
  isShared: boolean;
  rank: number;
  reportName: string;
  reportPages: IReportPage[];
  reportWebUrl: string;
  sharedBy: string;
  sharedDate: string;
  type: number;
  sharingDetails: {
    isShareable: boolean;
    reason: string;
  };
}

export interface IReportPage {
  id: string;
  name: string;
  order: number;
  webUrl: string;
  embedPath: string;
}

export interface ITableauEmbedData {
  embedUrl: string;
  id: string;
  name: string;
  server: string;
  ticket: string;
}

export interface IPowerBiReportTab {
  defaultDisplayOption: number;
  defaultSize: any;
  isActive: boolean;
  name: string;
  report: any;
  visibility: number;
  displayName: string;
  setActive: () => void;
}

export interface IPowerBiEmbedData {
  embedToken: {
    expiration: any;
    token: string;
    tokenId: any;
  };
  embedUrl: string;
  id: string;
  name: string;
  tokenType: string;
}

// Files
export const ACCOUNTS_PAYABLE = 'accounts-payable' as TFileSection;
export const ACCOUNTS_RECEIVABLES = 'accounts-receivables' as TFileSection;
export const INVENTORY = 'inventory' as TFileSection;

export const UPLOADED = 'Uploaded' as TFileStatus;
export const MAPPING = 'Mapping' as TFileStatus;
export const STAGED = 'Staged' as TFileStatus;
export const DOWNLOADING = 'Downloading' as TFileStatus;
export const DELETED = 'Deleted' as TFileStatus;

export type TFileSection =
  | 'accounts-payable'
  | 'accounts-receivables'
  | 'inventory';
export type TFileStatus =
  | 'Uploaded'
  | 'Mapping'
  | 'Staged'
  | 'Downloading'
  | 'Deleted';
export type TPublishStatus =
  | 'None'
  | 'Started'
  | 'Queued'
  | 'Completed'
  | 'Failed';
export const SECTIONS_NAME_MAP: {
  [key: string]: TFileSection;
} = {
  AccountsPayable: ACCOUNTS_PAYABLE,
  AccountsReceivables: ACCOUNTS_RECEIVABLES,
  Inventory: INVENTORY,
};

export const SECTIONS_MAP = {
  [ACCOUNTS_PAYABLE]: 'AccountsPayable',
  [ACCOUNTS_RECEIVABLES]: 'AccountsReceivables',
  [INVENTORY]: 'Inventory',
};

export const FILE_STATUSES_MAP = {
  [UPLOADED]: 0,
  [MAPPING]: 1,
  [STAGED]: 2,
  [DOWNLOADING]: 3,
};

export interface IUploadedFile {
  id: number;
  name: string;
  section: TFileSection;
  userName: string;
  status: TFileStatus;
  sessionId: string;
  uploadDate: string;
  isMine: boolean;
  canDelete?: boolean;
  expirationDate?: string;
}

export interface IUploadingFilesData {
  userName: string;
}

export const SESSION_CREATED = 'Created';
export const SESSION_UPLOADED = 'Uploaded';
export const SESSION_DELETED = 'Deleted';
export const SESSION_TRANSFORMATION_DONE = 'TransformationDone';

export interface IOtherFilesBySection {
  [key: string]: IUploadedFile[];
}

export interface IUserFilesBySection {
  [key: string]: IUserFilesByStatus;
}

interface IUserFilesByStatus {
  [key: string]: IUserFilesBySession;
}

export interface IUserFilesBySession {
  [key: string]: IUploadedFile[];
}
